import { useEffect } from "react";

const TOKEN_KEY = "token";

const ViewAs = () => {
  useEffect(() => {
    const raw = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "";
    const token = raw ? decodeURIComponent(raw) : "";
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
      window.location.replace("/customer"); // full reload → AuthContext reads sessionStorage first
    } else {
      window.location.replace("/login");
    }
  }, []);
  return null;
};

export default ViewAs;
